import React, { Component } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import {
  updateEngagementTypeStatus,
  searchEngagementType
} from './EngagementTypeService';
import CreatedDateCell from './components/CreatedDateCell';
import UpdatedDateCell from './components/UpdatedDateCell';
import StatusCell from './components/StatusCell';
import EditEngagementTypeActionsCell from './components/EditEngagementTypeActionsCell';
import { ComboBox } from '@progress/kendo-react-dropdowns';

import { Link } from 'react-router-dom';
import { orderBy } from '@progress/kendo-data-query';
import Loader from '../../integration/components/Loader';
import SuccessImg from '../../ui/static/images/checked.svg';
import ErrorImg from '../../ui/static/images/cancel.svg';
import * as loggerService from "../../../src/integration/LoggerService";
import {LOG_TYPES} from "../../integration/IntegrationEnums";

class EngagementType extends Component {

  isMount = false;

  componentDidMount() {
    window.scrollTo(0, 0);
    this.isMount = true;
    this.populateEngagementTypes();
    this.setHeaderTitle();
  }

  componentWillUnmount() {
    this.isMount = false;
  }

  setHeaderTitle = async () => {
    if (this.isMount && this.props.onHeaderTitleChange) {
      this.props.onHeaderTitleChange('Engagement Type');
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      engagementTypes: [],
      skip: 0,
      take: 20,
      SearchRequest: {
        EngagementTypeName: '',
        searchStatus: null
      },
      deactivateEngagementTypeId: 0,
      deactivatePopupVisible: false,
      activateEngagementType: 0,
      status: [{ Name: 'Active', status: true }, { Name: 'Inactive', status: false }],
      activatePopupVisible: false,
      sort: [{ field: 'updatedAt', dir: 'desc' }],
      loading: false
    };
  }

  populateEngagementTypes = () => {
    searchEngagementType().then(response => {
      if (this.isMount) {
        this.setState({
          engagementTypes: response.data
        });
      }
    })
    .catch(error => {
      loggerService.writeLog(error, LOG_TYPES.ERROR);
    });
  };

  pageChange = event => {
    if (this.isMount) {
      this.setState({
        skip: event.page.skip,
        take: event.page.take
      });
    }
  };

  toggleDialog = (message, title) => {
    if (this.isMount) {
      this.setState({
        showMessageDialog: !this.state.showMessageDialog,
        dialogMessage: message,
        dialogTitle: title
      });
    }
  };

  render() {
    return (
      <div>
        <div className="main-card">
          <div className="row">
            <div className="col-md-8">
              <div className="main-heading">Engagement Type Search</div>
            </div>

            <div className="col-md-4">


              <Button primary={true} className="pull-right" disabled={!(window.USER_PERMISSION.indexOf('ED_ENG') > -1)}>

                <Link
                  style={{ textDecoration: 'none', color: 'white' }}
                  to={{
                    pathname:
                      '/masterdata/createengagementtype/createengagementtype',
                    action: 'create'
                  }}
                >
                  Create New Engagement Type
                </Link>

              </Button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <div className="d-block">
                  <label>Engagement Type Name:</label>
                </div>
                <div className="d-block">
                <div className="">
                  <Input
                    value={this.state.SearchRequest.EngagementTypeName}
                    onChange={this.handleOnChangeInput}
                    name="EngagementTypeName"
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-2">
              <div className="d-block">
                <div className=""><label>Status:</label></div>
                </div>
                <div className="d-block">
                <div className="">
                  <ComboBox
                    name="searchStatus"
                    textField="Name"
                    dataItemKey="status"
                    value={this.state.SearchRequest.searchStatus}
                    data={this.state.status}
                    placeholder={'Please Select'}
                    onChange={this.handleOnChangeInput}/>
                </div>
              </div>
            </div>
            </div>

                  <div className="row">
            <div className="col-md-12 btn-align-right">
              <Button primary={true} type="submit" onClick={this.submitSearch} >
                Search
              </Button>
              <Button
                type="button"
                onClick={this.cancelSearch}
                style={{ marginRight: '5px' }}
              >
                Clear
              </Button>
            </div>
          </div>          

          <div className="main-seperator"/>

          <div className="row">
            <div className="col-md-12">
              <div className="main-heading">Search Results</div>
            </div>
          </div>

          <div className="row mt-0">
            <div className="col-md-12">
              <Grid
                data={orderBy(this.state.engagementTypes, this.state.sort).slice(
                  this.state.skip,
                  this.state.take + this.state.skip
                )}
                skip={this.state.skip}
                take={this.state.take}
                total={this.state.engagementTypes.length}
                pageable={true}
                onPageChange={this.pageChange}
                resizable
                sortable={true}
                sort={this.state.sort}
                onSortChange={(e) => {
                  this.setState({
                    sort: e.sort
                  });
                }
                }
                className="search-result-grid"
              >
                <Column field="Name" title="Engagement Type"/>
                <Column
                  field="createdAt"
                  title="Created Date"
                  cell={props => <CreatedDateCell {...props} />}
                />
                <Column
                  field="updatedAt"
                  title="Last Modified Date"
                  cell={props => <UpdatedDateCell {...props} />}
                />
                <Column field="updatedUser" title="Last Modified User"  width="120px"/>
                <Column
                  field="IsActive"
                  width="100px"
                  title="Status"
                  cell={props => <StatusCell {...props} />}
                />
                <Column
                  field=""
                  title="Actions"
                  width="150px"
                  cell={props => (
                    <EditEngagementTypeActionsCell
                      {...props}
                      OnDeactivate={this.OnDeactivate}
                      OnActivate={this.OnActivate}
                    />
                  )}
                />
              </Grid>
            </div>
          </div>
          <div>
            {this.state.deactivatePopupVisible && (
              <Dialog
                title={'Please Confirm'}
                onClose={this.deactivateConfirmationClose}
              >
                <p style={{ margin: '25px', textAlign: 'center' }}>
                  Are you sure you want to Deactivate this?
                </p>
                <DialogActionsBar>
                  <button
                    className="k-button"
                    onClick={this.deactivateConfirmationClose}
                  >
                    No
                  </button>
                  <button
                    className="k-button modal-primary"
                    onClick={this.deactivateConfirmationOk}
                  >
                    Yes
                  </button>
                </DialogActionsBar>
              </Dialog>
            )}
          </div>
          <div>
            {this.state.activatePopupVisible && (
              <Dialog
                title={'Please Confirm'}
                onClose={this.activateConfirmationClose}
              >
                <p style={{ margin: '25px', textAlign: 'center' }}>
                  Are you sure you want to Activate this?
                </p>
                <DialogActionsBar>
                  <button
                    className="k-button"
                    onClick={this.activateConfirmationClose}
                  >
                    No
                  </button>
                  <button
                    className="k-button modal-primary"
                    onClick={this.activateConfirmationOk}
                  >
                    Yes
                  </button>
                </DialogActionsBar>
              </Dialog>
            )}

            {this.state.showMessageDialog === true && (
              <Dialog title={this.state.dialogTitle} onClose={this.toggleDialog} width="400px">

                {this.state.showSuccessImage === true && (
                  <div className="text-center">
                    <img className="successImg" src={SuccessImg} alt="Success"/>
                  </div>
                )}

                {this.state.showErrorImage === true && (
                  <div className="text-center">
                    <img className="successImg" src={ErrorImg} alt="Error"/>
                  </div>
                )}
                <p style={{ margin: '25px', textAlign: 'center' }}>{this.state.dialogMessage}</p>

                <DialogActionsBar>
                  {this.state.showSuccessImage === true && (
                    <button className="k-button modal-primary" onClick={this.toggleDialog}>
                      OK
                    </button>
                  )}

                  {this.state.showErrorImage === true && (
                    <button className="k-button " onClick={this.toggleDialog}>
                      OK
                    </button>
                  )}
                </DialogActionsBar>
              </Dialog>
            )}
          </div>
          <Loader loading={this.state.loading}/>
        </div>
      </div>
    );
  }

  submitSearch = event => {
    event.preventDefault();
    if (this.isMount) {
      this.setState({
        loading: true
      });

      this.setState(
        prevState => {
          const SRequest = {
            ...prevState.SearchRequest
          };
          return {
            SearchRequest: SRequest
          };
        },
        () => {
          searchEngagementType(this.state.SearchRequest).then(res => {
            this.setState({
              engagementTypes: res.data,
              loading: false,
              skip: 0
            });
          })
          .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
          });
        }
      );
    }
  };

  activateConfirmationOk = async () => {
    await updateEngagementTypeStatus(
      { IsActive: true },
      this.state.activateEngagementTypeId
    )
      .then(response => {
        if (this.isMount) {
          this.setState({
            showSuccessImage: true,
            showErrorImage: false
          });
        }
        this.toggleDialog(
          'The Engagement type has been Activated successfully',
          'Success'
        );
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
    await this.populateEngagementTypes();
    if (this.isMount) {
      await this.setState({
        activatePopupVisible: false,
        showSuccessImage: false,
        showErrorImage: true
      });
    }
  };

  cancelSearch = event => {
    event.preventDefault();
    if (this.isMount) {
      this.setState({
        SearchRequest: {
          EngagementTypeName: '',
          searchStatus: null
        }
      });
    }
    this.populateEngagementTypes();
  };

  handleOnChangeInput = event => {
    const field = event.target.name;
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;

    if (this.isMount) {
      this.setState(prevState => {
        return {
          SearchRequest: { ...prevState.SearchRequest, [field]: value }
        };
      });
    }
  };

  OnDeactivate = async (event, id) => {
    event.preventDefault();
    if (this.isMount) {
      await this.setState({
        deactivateEngagementTypeId: id
      });
    }
    this.deactivateConfirmationClose();
  };

  deactivateConfirmationClose = async () => {
    if (this.isMount) {
      await this.setState({
        deactivatePopupVisible: !this.state.deactivatePopupVisible
      });
    }
  };

  deactivateConfirmationOk = async () => {
    await updateEngagementTypeStatus(
      { IsActive: false },
      this.state.deactivateEngagementTypeId
    )
      .then(response => {
        if (this.isMount) {
          this.setState({
            showSuccessImage: true,
            showErrorImage: false
          });
        }
        this.toggleDialog(
          'The Engagement type has been Deactivated successfully',
          'Success'
        );
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
    await this.populateEngagementTypes();
    await this.setState({
      deactivatePopupVisible: false
    });
  };

  OnActivate = async (event, id) => {
    event.preventDefault();
    if (this.isMount) {
      await this.setState({
        activateEngagementTypeId: id
      });
    }
    this.activateConfirmationClose();
  };

  activateConfirmationClose = async () => {
    if (this.isMount) {
      await this.setState({
        activatePopupVisible: !this.state.activatePopupVisible
      });
    }
  };

  activateConfirmationOk = async () => {
    await updateEngagementTypeStatus({ IsActive: true },
      this.state.activateEngagementTypeId
    )
      .then(response => {
        if (this.isMount) {
          this.setState({
            showSuccessImage: true,
            showErrorImage: false
          });
        }
        this.toggleDialog(
          'The Engagement type has been Activated successfully',
          'Success'
        );
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
    await this.populateEngagementTypes();
    if (this.isMount) {
      await this.setState({
        activatePopupVisible: false
      });
    }
  };
}

export default EngagementType;
